import React, { useState } from 'react';

const UseAuth = () => {
  const [tokenize] = useState(() => window.localStorage.getItem('token') || false);
  const user = { isLoggedInUser: tokenize };
  return user && user.isLoggedInUser;
};

export default UseAuth;
